(function($){

    jQuery.extend(jQuery, {
        imagesToLoad: 0,
        loadedImages: [],
        preloadImages: function(){
            var settings = {
                urls : [],
                begin : function(){},
                each : function(){},
                complete : function(){},
                scope: window
            };
            jQuery.extend(settings, arguments[0]);
            var images = [];
    
            jQuery.imagesToLoad = settings.urls.length;
    
            settings.begin.call(settings.scope, settings.urls);
            for(var i = 0; i < settings.urls.length; i++){
                images[i] = new Image();
                images[i].onload = function(){
                    settings.each.call(settings.scope,this);
                    jQuery.loadedImages.push(this);
                    if(jQuery.loadedImages.length >= jQuery.imagesToLoad){
                        settings.complete.call(settings.scope,jQuery.loadedImages);
                    }
                }
                images[i].src= settings.urls[i];
            }
        }
    });

    $(document).ready(function() {

        var discount = $('#discountedPrice').data('discount');
        discount = parseFloat(discount);
        var totalWeight = 0;
        var priceArray = [];
        var weightArray = [];
        var productArray = [];
        var stockArray = [];
        const sumValues = obj => Object.values(obj).reduce((a, b) => a + b, 0);

        var part = "deck";

        var prevDeck = JSON.parse(sessionStorage.getItem("deck"));
        var prevForks = JSON.parse(sessionStorage.getItem("forks"));
        var prevClamp = JSON.parse(sessionStorage.getItem("clamp"));
        var prevBars = JSON.parse(sessionStorage.getItem("bars"));
        var prevHeadset = JSON.parse(sessionStorage.getItem("headset"));
        var prevFrontWheel = JSON.parse(sessionStorage.getItem("frontWheel"));
        var prevRearWheel = JSON.parse(sessionStorage.getItem("rearWheel"));
        var prevGriptape = JSON.parse(sessionStorage.getItem("griptape"));
        var prevGrips = JSON.parse(sessionStorage.getItem("grip"));
        var prevShims = JSON.parse(sessionStorage.getItem("shims"));

        var prevBarType = JSON.parse(sessionStorage.getItem("prevBarType"));
        var prevForkType = JSON.parse(sessionStorage.getItem("prevForkType"));
        var prevClampType = JSON.parse(sessionStorage.getItem("prevClampType"));

        var forksSelected = false;
        var barsSelected = false;
        var clampSelected = false;
        var barType;
        var forkType;
        var clampType;

        if (prevBarType){
          barsSelected = true;
          barType = prevBarType;
          console.log(barType);
        }
        if (prevForkType){
          forksSelected = true;
          forkType = prevForkType;
          console.log(forkType);
        }
        if (prevClampType){
          clampSelected = true;
          clampType = prevClampType;
          console.log(clampType);
        }

        /* Reset EVERYTHING function  */

        $('#resetAll').click(function(){
          resetAll(true);
        });

        function resetAll(backtoInitial){
            priceArray = [];
            weightArray = [];
            productArray = [];
            stockArray = [];
            $('#totalPrice').text(0);
            $('#discountedPrice').text(0);
            $('#totalWeight').text(0);
            $('.componentBtn').find('.previewImage').removeClass('oos');
            $('.componentBtn').find('.previewImage').empty();
            $('.componentBtn').find('.description').text('SELECT PRODUCT');
            $('#compression-shims').find('.description').text('AUTOMATICALLY ADDED');
            $('.componentBtn').find('.price').empty();
            $('.componentBtn').removeClass('selected');
            $('#griptape').empty();
            $('#clamp').empty();
            $('#headset').empty();
            $('#deck').empty();
            $('#grip').empty();
            $('#bars').empty();
            $('#forks').empty();
            $('#frontWheel').empty();
            $('#rearWheel').empty();
            if (backtoInitial){
              $('#initial').fadeIn(500);
            }
            sessionStorage.removeItem('deck');
            sessionStorage.removeItem('forks');
            sessionStorage.removeItem('clamp');
            sessionStorage.removeItem('bars');
            sessionStorage.removeItem('headset');
            sessionStorage.removeItem('frontWheel');
            sessionStorage.removeItem('rearWheel');
            sessionStorage.removeItem('griptape');
            sessionStorage.removeItem('grip');
            sessionStorage.removeItem('shims');
            sessionStorage.removeItem('prevBarType');
            sessionStorage.removeItem('prevClampType');
            sessionStorage.removeItem('prevForkType');
            forksSelected = false;
            barsSelected = false;
            clampSelected = false;
            barType = "";
            forkType = "";
            clampType = "";
        }

        /* Check the session variables for previous scooter builder items  */

        if (prevDeck){
          setupPrevious("deck",prevDeck);
        }
        if (prevForks){
          setupPrevious("forks",prevForks);
        }
        if (prevClamp){
          setupPrevious("clamp",prevClamp);
        }
        if (prevBars){
          setupPrevious("bars",prevBars);
        }
        if (prevHeadset){
          setupPrevious("headset",prevHeadset);
        }
        if (prevFrontWheel){
          setupPrevious("frontWheel",prevFrontWheel);
        }
        if (prevRearWheel){
          setupPrevious("rearWheel",prevRearWheel);
        }
        if (prevGriptape){
          setupPrevious("griptape",prevGriptape);
        }
        if (prevGrips){
          setupPrevious("grip",prevGrips);
        }
        if (prevShims){
          setupPrevious("shims",prevShims);
        }

        function setupPrevious(id,prevProduct){
          $('#initial').fadeOut(500);
          $('#'+id).html('<img src="'+prevProduct.image+'" />');
          var thisComponent = $('.componentBtn[data-part="'+id+'"]');
          thisComponent.addClass('selected');
          thisComponent.find('.previewImage').html('<img src="'+prevProduct.thumb+'" />');
          thisComponent.find('.description').text(prevProduct.title);
          thisComponent.find('.price').text('- £'+prevProduct.price);
          if(!prevProduct.available){
            thisComponent.find('.previewImage').addClass('oos');
          }
          priceArray[id] = prevProduct.price;
          weightArray[id] = prevProduct.grams;
          productArray[id] = prevProduct.variant;
          stockArray[id] = prevProduct.available;
          var totalPrice = (Math.round(sumValues(priceArray) * 100) / 100);
          var discountPrice = totalPrice - (totalPrice * (discount/100));
          $('#totalPrice').text(totalPrice.toFixed(2));
          $('#discountedPrice').text(discountPrice.toFixed(2));
          $('#totalWeight').text((Math.round(sumValues(weightArray) * 100) / 100000).toFixed(2));
        }

        /* SCOOTER IMAGE DOWNLOAD LOGIC */

        var scooterImage = $("#scooterImage");
        var builderImage = $("#builderImage");
        var builderImageData = $("#builderImageData");
      
          $("#downloadImage").on('click', function () {

            var scooterImageHtml = $(scooterImage).html();
            $(builderImageData).html(scooterImageHtml);
  
            html2canvas(builderImage, {
                scale:2,
                width: 3000,
                height: 3000,
                allowTaint: false,
                logging:true,
                useCORS:true,
                onrendered: function (canvas) {
                    var imageData = canvas.toDataURL('image/png');            
                    var image = new Image();
                    image.src = imageData;
                    var a = document.createElement('a');
                    a.href = canvas.toDataURL("image/png");
                    a.download = 'core-scooter-builder.png';
                    a.click();
                }
            });
          
        });

        /* SCOOTER SHARE LOGIC */

        $('#generateLink').click(generateLink);
      
        function generateLink(){
          var baseUrl = window.location.href;
          
          function getPathFromUrl(url) {
            return url.split("?")[0];
          }
          
          var link = getPathFromUrl(baseUrl);
          link = link+"?sharescooter=true";
          
          var deck = JSON.parse(sessionStorage.getItem("deck"));
          var forks = JSON.parse(sessionStorage.getItem("forks"));
          var clamp = JSON.parse(sessionStorage.getItem("clamp"));
          var bars = JSON.parse(sessionStorage.getItem("bars"));
          var headset = JSON.parse(sessionStorage.getItem("headset"));
          var frontWheel = JSON.parse(sessionStorage.getItem("frontWheel"));
          var rearWheel = JSON.parse(sessionStorage.getItem("rearWheel"));
          var griptape = JSON.parse(sessionStorage.getItem("griptape"));
          var grips = JSON.parse(sessionStorage.getItem("grip"));
          var shims = JSON.parse(sessionStorage.getItem("shims"));

          if (deck){
            link = link+"&deck="+deck.handle;
          }
          if (forks){
            link = link+"&forks="+forks.handle;
          }
          if (clamp){
            link = link+"&clamp="+clamp.handle;
          }
          if (bars){
            link = link+"&bars="+bars.handle;
          }
          if (headset){
            link = link+"&headset="+headset.handle;
          }
          if (frontWheel){
            link = link+"&frontWheel="+frontWheel.handle;
          }
          if (rearWheel){
            link = link+"&rearWheel="+rearWheel.handle;
          }
          if (griptape){
            link = link+"&griptape="+griptape.handle;
          }
          if (grips){
            link = link+"&grip="+grips.handle;
          }
          if (shims){
            link = link+"&shims="+shims.handle;
          }

          console.log("long link - "+link);

          var api_url  = 'https://builder.ridecore.pro/yourls-api.php';
          var response = $.get( api_url, {
              username: "therealwesty",
              password: "C0r3s00t3r5!",
              action:   "shorturl",
              format:   "json",
              url:      link
              },
              // callback function that will deal with the server response
              function( data) {
                  // now do something with the data, for instance show new short URL:
                  $('#shareLink').text(data.shorturl);
                  $('#sharePopup').addClass('open');
                  $('#sharePopup .closePopup').click(function(){
                    $('#sharePopup').removeClass('open');
                  });
                  $('#shareLink').click(function(){
                    var $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val($(this).text()).select();
                    document.execCommand("copy");
                    $temp.remove();
                    $(this).addClass('copied');
                  });
                  console.log(data.shorturl);
              }
          );

        }

        const params = new Proxy(new URLSearchParams(window.location.search), {
          get: (searchParams, prop) => searchParams.get(prop),
        });
        // Get the value of "sharescooter" in eg "https://ridecore.pro/pages/custom-scooter-builder?sharescooter=true"
        var sharescooter = params.sharescooter; // "true"

        if(sharescooter){
          console.log("SHARED SCOOTER");
          resetAll(false);
          $('#initial').fadeOut(500);

          var deckHandle = params.deck;
          var forksHandle = params.forks;
          var clampHandle = params.clamp;
          var barsHandle = params.bars;
          var headsetHandle = params.headset;
          var fWheelHandle = params.frontWheel;
          var rWheelHandle = params.rearWheel;
          var griptapeHandle = params.griptape;
          var gripsHandle = params.grip;
          var shimHandle = params.shim;

          if(deckHandle){
            console.log(deckHandle);
            setupSharedBuilder("deck", deckHandle);
          }
          if(forksHandle){
            console.log(forksHandle);
            setupSharedBuilder("forks", forksHandle);
          }
          if(clampHandle){
            console.log(clampHandle);
            setupSharedBuilder("clamp", clampHandle);
          }
          if(barsHandle){
            console.log(barsHandle);
            setupSharedBuilder("bars", barsHandle);
          }
          if(headsetHandle){
            console.log(headsetHandle);
            setupSharedBuilder("headset", headsetHandle);
          }
          if(fWheelHandle){
            console.log(fWheelHandle);
            setupSharedBuilder("frontWheel", fWheelHandle);
          }
          if(rWheelHandle){
            console.log(rWheelHandle);
            setupSharedBuilder("rearWheel", rWheelHandle);
          }
          if(griptapeHandle){
            console.log(griptapeHandle);
            setupSharedBuilder("griptape", griptapeHandle);
          }
          if(gripsHandle){
            console.log(gripsHandle);
            setupSharedBuilder("grip", gripsHandle);
          }
          if(shimHandle){
            console.log(shimHandle);
            setupSharedBuilder("shim", shimHandle);
          }

          function setupSharedBuilder(partLabel,handle){
                var productHandle = handle;
                var productUrl = "https://ridecore.pro/products/"+productHandle;

                jQuery.getJSON(productUrl + '.js', function(product){

                   var productTitle = product.title;
                   var productMetafields = metafields[productHandle];
                   var builderImage = productMetafields.product_builder_image;
                   var builderThumbnail = productMetafields.product_thumbnail;
                   var productAvailable = product.available;
                   var productVariantId = product.variants[0].id;
                   var productPrice = product.variants[0].price;
                   productPrice = Number((productPrice / 100).toFixed(2));
                   var productGrams = product.variants[0].weight;
                  
                   sessionStorage.setItem([partLabel], JSON.stringify({handle:productHandle, title: productTitle, url:productUrl, variant:productVariantId, image:builderImage, thumb:builderThumbnail, price: productPrice, grams:productGrams, available:productAvailable}));

                  //console.log(productMetafields);

                  checkifShimNeeded();

                  if(partLabel=="forks"){
                    forkType = productMetafields.fork_type;
                    console.log(forkType);
                    forksSelected = true;
                    checkifShimNeeded();
                    sessionStorage.setItem("prevForkType",JSON.stringify(forkType));
                  }
                  else if(partLabel=="clamp"){
                    clampType = productMetafields.clamp_type;
                    console.log(clampType);
                    clampSelected = true;
                    checkifShimNeeded();
                    sessionStorage.setItem("prevClampType",JSON.stringify(clampType));
                  }
                  else if(partLabel=="bars"){
                    barType = productMetafields.bar_type;
                    console.log(barType);
                    barsSelected = true;
                    checkifShimNeeded();
                    sessionStorage.setItem("prevBarType",JSON.stringify(barType));
                  }

                  
                   if ($('#'+partLabel).length){
                     $('#'+partLabel).html('<img src="'+builderImage+'" />');
                   }
                  
                   if(!productAvailable){
                      $('.componentBtn[data-part="'+partLabel+'"]').find('.previewImage').addClass('oos');
                   }
                   else{
                      $('.componentBtn[data-part="'+partLabel+'"]').find('.previewImage').removeClass('oos');
                   }
                   
                   $('.componentBtn[data-part="'+partLabel+'"]').find('.previewImage').html('<img src="'+builderThumbnail+'" />');
                   $('.componentBtn[data-part="'+partLabel+'"]').find('.description').text(productTitle);
                   $('.componentBtn[data-part="'+partLabel+'"]').find('.price').text('- £'+productPrice);
                   $('.componentBtn[data-part="'+partLabel+'"]').addClass('selected');

                   priceArray[partLabel] = productPrice;
                   weightArray[partLabel] = productGrams;
                   productArray[partLabel] = productVariantId;
                   stockArray[partLabel] = productAvailable;
                   var totalPrice = (Math.round(sumValues(priceArray) * 100) / 100);
                   var discountPrice = totalPrice - (totalPrice * (discount/100));
                   $('#totalPrice').text(totalPrice.toFixed(2));
                   $('#discountedPrice').text(discountPrice.toFixed(2));
                   $('#totalWeight').text((Math.round(sumValues(weightArray) * 100) / 100000).toFixed(2));
                    
                });
          }
          
          
        }

        
        /* Remove Single Items on click of delete buttons */

        var currentProduct;

         $('.remove').on('click', function(){
           
           part = $(this).parent().data('part');

           if (priceArray[part]){
              delete priceArray[part];
           }
  
           if (weightArray[part]){
              delete weightArray[part];
           }
  
           if (productArray[part]){
             delete productArray[part];
           }
  
           if (stockArray[part]){
             delete stockArray[part];
           }

           var totalPrice = (Math.round(sumValues(priceArray) * 100) / 100);
           var discountPrice = totalPrice - (totalPrice * (discount/100));
           $('#totalPrice').text(totalPrice.toFixed(2));
           $('#discountedPrice').text(discountPrice.toFixed(2));
           $('#totalWeight').text((Math.round(sumValues(weightArray) * 100) / 100000).toFixed(2));
           
           $('.componentBtn[data-part="'+part+'"]').find('.previewImage').removeClass('oos');
           $('.componentBtn[data-part="'+part+'"]').find('.previewImage').empty();
           $('.componentBtn[data-part="'+part+'"]').find('.description').text('SELECT PRODUCT');
           $('.componentBtn[data-part="'+part+'"]').find('.price').empty();
           $('.componentBtn[data-part="'+part+'"]').removeClass('selected');
           $('#'+part).empty();
           sessionStorage.removeItem(part);

           if (part == 'forks'){
             forksSelected = false;
             forkType = "";
             checkifShimNeeded();
           }
           else if(part == 'clamp'){
             clampSelected = false;
             clampType = "";
             checkifShimNeeded();
           }
           else if(part == 'bars'){
             barsSelected = false;
             barType = "";
             checkifShimNeeded();
           }
           
         });

        /* Listen for clicks on component buttons and open popup with products loaded */

        $('.componentBtn .title').click(openProductPop);
        $('.componentBtn .description').click(openProductPop);
        $('.componentBtn .previewImage').click(openProductPop);

        function openProductPop(){

          var productType = $(this).parent().attr("id");
          part = $(this).parent().data('part');
          
          var productTitle = $(this).parent().find('.title').text();
          $('#productTitle').text(part);
          $('#productDescription').text(part);
          
          var productUrl = productType;
          currentProduct = productType;
          
          if (productType == 'scooter-wheel-front'){
            productUrl = "scooter-wheels";
          }
          else if (productType == 'scooter-wheel-rear'){
            productUrl = "scooter-wheels";
          }
          else if (productType == 'compression-shims'){
            return;
          }
          $('.productHolder').empty();

          var getProducts = $.ajax({
            url:	"/collections/"+productUrl+"/products.json",
            type:	'GET'
            });

          $('#preloader').addClass('open');
                     
          getProducts.done(function(data) {
            
              var imageUrls = [];
               
               for (var i = 0, l = data.products.length; i < l; i++) {
                 
                    var product = data.products[i];
                    var productVariant = product.variants[0];
                    var available = productVariant.available;
                    var variantId = productVariant.id;
                    var title = product.title;
                    var price = productVariant.price;
                    var image = product.images[0].src;
                    var handle = product.handle;
                    var grams = productVariant.grams;

                    var productMetafields = metafields[handle];

                    /* ------------ FORK COMPATABILITY LOGIC ------------ */

                    if(productType=="scooters-scooter-parts-forks"){
                      var currentType = productMetafields.fork_type;
                      
                      if(barsSelected && clampSelected){
                        console.log("bars and clamp already selected!");
                        if(barType == "Aluminium"){
                          if(clampType == "Double Clamp"){
                            console.log('only show forks compatible with Double Clamp & Alu Bars - IHC Forks');
                            if(currentType == "IHC Forks"){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                            }
                          }
                          else if(clampType == "SCS Clamp"){
                            console.log('only show forks compatible with SCS Clamp & Alu Bars - COMBINATION NOT POSSIBLE');
                          }
                        }
                        else if(barType == "Titanium"){
                          if(clampType == "Double Clamp"){
                            console.log('only show forks compatible with Double Clamp & Ti Bars - ALL FORKS (WITH IHC TO HIC CONVERSION SHIM KIT 3MM)');
                            imageUrls.push(image);
                            $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                          }
                          else if(clampType == "SCS Clamp"){
                            console.log('only show forks compatible with SCS Clamp & Ti Bars - SCS / HIC Forks');
                            if(currentType == "SCS / HIC Forks"){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                            }
                          }
                        }
                        else if(barType == "Steel"){
                          if(clampType == "Double Clamp"){
                            console.log('NO FORKS COMPATIBLE)');
                          }
                          else if(clampType == "SCS Clamp"){
                            console.log('only show forks compatible with SCS Clamp & Steel Bars - SCS / HIC FORKS');
                            if(currentType == "SCS / HIC Forks"){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                            }
                          }
                        }
                      }
                        
                      else if (barsSelected && !clampSelected){
                        console.log("bars already selected!");
                        if(barType == "Aluminium"){
                          console.log('only show forks compatible with Alu Bars - IHC FORKS');
                          if(currentType == "IHC Forks"){
                            imageUrls.push(image);
                            $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                          }
                        }
                        else if(barType == "Titanium"){
                          console.log('only show forks compatible with Ti Bars (all forks)');
                          imageUrls.push(image);
                          $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                        }
                        else if(barType == "Steel"){
                          console.log('only show forks compatible with Steel Bars - SCS / HIC Forks');
                          if(currentType == "SCS / HIC Forks"){
                            imageUrls.push(image);
                            $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                          }
                        }
                      }
                        
                      else if (!barsSelected && clampSelected){
                        console.log("clamp already selected!");
                        console.log(clampType);
                        if(clampType == "Double Clamp"){
                          console.log('only show forks compatible with Double Clamp (ALL FORKS)');
                          imageUrls.push(image);
                          $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                        }
                        else if(clampType == "SCS Clamp"){
                          console.log('only show forks compatible with SCS Clamp - SCS / HIC Forks');
                          if(currentType == "SCS / HIC Forks"){
                            imageUrls.push(image);
                            $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                          }
                        }
                      }
                        
                      else{
                        console.log("no compatability issues already selected!");
                        imageUrls.push(image);
                        $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                      }
                      
                    }

                    /* ------------ CLAMP COMPATABILITY LOGIC ------------ */

                    else if(productType=="scooters-scooter-parts-clamps"){
                      var currentType = productMetafields.clamp_type;
                      
                      if(barsSelected && forksSelected){
                        console.log("bars and forks already selected!");
                        if(barType == "Aluminium"){
                          if(forkType == "IHC Forks"){
                            console.log('only show clamps compatible with IHC Forks & Alu Bars - Double Clamp');
                            if(currentType == "Double Clamp"){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                            }
                          }
                          else if(forkType == "SCS / HIC Forks"){
                            console.log('only show clamps compatible with SCS / HIC Forks & Alu Bars  - COMBINATION NOT POSSIBLE');
                          }
                        }
                        else if(barType == "Titanium"){
                          if(forkType == "IHC Forks"){
                            console.log('only show clamps compatible with IHC Forks & Ti Bars - Any Clamp WITH FORK ADAPTER IHC TO HIC CONVERSION SHIM');
                            if(currentType == "Double Clamp"){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                            }
                          }
                          else if(forkType == "SCS / HIC Forks"){
                            console.log('only show clamps compatible with SCS / HIC Forks & Ti Bars - SCS Clamp');
                            imageUrls.push(image);
                            $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');

                          }
                        }
                        else if(barType == "Steel"){
                          if(forkType == "IHC Forks"){
                            console.log('only show clamps compatible with IHC Forks & Steel Bars -  COMINATION NOT POSSIBLE');
                          }
                          else if(forkType == "SCS / HIC Forks"){
                            console.log('only show clamps compatible with SCS / HIC Forks & Steel Bars - SCS CLAMPS');
                            if(currentType == "SCS Clamp"){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                            }
                          }
                        }
                      }
                        
                      else if (barsSelected && !forksSelected){
                        console.log("bars already selected!");
                        if(barType == "Aluminium"){
                          console.log('only show clamps compatible with Alu Bars - Double Clamp');
                          if(currentType == "Double Clamp"){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                          }
                        }
                        else if(barType == "Titanium"){
                          console.log('only show clamps compatible with Ti Bars (Any clamp)');
                          imageUrls.push(image);
                          $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                        }
                        else if(barType == "Steel"){
                          console.log('only show clamps compatible with Steel Bars (SCS clamps)');
                          if(currentType == "SCS Clamp"){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                          }
                        }
                      }
                        
                      else if (!barsSelected && forksSelected){
                        console.log("forks already selected!");
                        console.log(forkType);
                        if(forkType == "IHC Forks"){
                          console.log('only show clamps compatible with IHC Forks - Double Clamps');
                          if(currentType == "Double Clamp"){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                            }
                        }
                        else if(forkType == "SCS / HIC Forks"){
                          console.log('only show forks compatible with SCS / HIC Forks - SCS Clamps');
                          imageUrls.push(image);
                          $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');

                        }
                      }
                        
                      else{
                        console.log("no compatability issues already selected!");
                        imageUrls.push(image);
                        $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                      }
                      
                    }

                    /* ------------ BARS COMPATABILITY LOGIC ------------ */

                    else if(productType=="scooter-handlebars"){
                      var currentType = productMetafields.bar_type;
                      
                      if(clampSelected && forksSelected){
                        console.log("clamp and forks already selected!");
                        if(forkType == "IHC Forks"){
                          if(clampType == "Double Clamp"){
                            console.log('only show bars compatible with Double Clamp & IHC Fork - ALU BARS + TI WITH FORK ADAPTER IHC TO HIC CONVERSION');
                            if((currentType == "Aluminium" || currentType == "Titanium")){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                            }
                          }
                          else if(clampType == "SCS Clamp"){
                            console.log('only show bars compatible with SCS Clamp & IHC Fork - NOT POSSIBLE');
                          }
                        }
                        else if(forkType == "SCS / HIC Forks"){
                          if(clampType == "Double Clamp"){
                            console.log('only show bars compatible with Double Clamp & SCS / HIC Forks -  STEEL + TI BARS WORK WITH FORK ADAPTER HIC CONVERSION SHIM');
                            if(currentType == "Titanium"){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                            }
                          }
                          else if(clampType == "SCS Clamp"){
                            console.log('only show bars compatible with SCS Clamp & SCS / HIC Forks - STEEL + TI');
                            if((currentType == "Steel" || currentType == "Titanium")){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                            }
                          }
                        }
                      }
                        
                      else if (!clampSelected && forksSelected){
                        console.log("forks already selected!");
                        if(forkType == "IHC Forks"){
                          console.log('only show bars compatible with IHC Forks - TI + ALU');
                          if((currentType == "Aluminium" || currentType == "Titanium")){
                            imageUrls.push(image);
                            $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                          }
                        }
                        else if(forkType == "SCS / HIC Forks"){
                          console.log('only show bars compatible with SCS / HIC Forks - TI + STEEL');
                          if((currentType == "Steel" || currentType == "Titanium")){
                              imageUrls.push(image);
                              $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                          }
                        }
                      }
                        
                      else if (clampSelected && !forksSelected){
                        console.log("clamp already selected: "+clampType);
                        if(clampType == "Double Clamp"){
                          console.log('only show bars compatible with Double Clamp (ALL BARS)');
                          imageUrls.push(image);
                          $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                        }
                        else if(clampType == "SCS Clamp"){
                          console.log('only show bars compatible with SCS Clamp - STEEL & TI');
                          if((currentType == "Steel" || currentType == "Titanium")){
                            imageUrls.push(image);
                            $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                          }
                        }
                      }
                        
                      else{
                        console.log("no compatability issues already selected!");
                        imageUrls.push(image);
                        $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                      }
                      
                    }
                      
                     else{
                        imageUrls.push(image);
                        $('.productHolder').append('<div class="product available-'+available+'"><div class="productImage"><img src="'+image+'"/></div><div class="productDescription">'+title+'</div><div class="productPrice">£'+price+'</div><div class="productAdd button slanted" data-handle="'+handle+'" data-product-type="deck" data-variantId="'+variantId+'" data-title="'+title+'" data-price="'+price+'" data-grams="'+grams+'" data-available="'+available+'"><div class="content">ADD</div></div></div>');
                     }
                    
                }

                $.preloadImages({
                    urls: imageUrls,
                    begin: function(urls){
                        //console.log("loading images %o", urls);
                    },
                    each: function(image){
                      //console.log("finished loading %s", image.src);
                    },
                    complete: function(images){
                      $('#preloader').removeClass('open');
                      $('#productPopup').addClass('open');
                    }
                });

              addToBuilderButtons();
               
            });
          
           getProducts.fail(function(data) {});
           getProducts.always(function(data) {});
        }

        $('.closePopup').click(function(){
          $('#productPopup').removeClass('open');
        })

        /* Set up add to builder buttons in pop up window */

        

        function addToBuilderButtons(){

            $('.product').click(function(){
              var thisBtn = $(this).find('.productAdd');
              addItemsToBuilder(thisBtn);
            });
          
            $('.productAdd').click(function(){
              var thisBtn = $(this);
              addItemsToBuilder(thisBtn);
            });

            function addItemsToBuilder(addBtn){

                $('#initial').fadeOut(500);

                var thisProduct = addBtn;
                var productHandle = addBtn.data("handle");
                var productTitle = addBtn.data("title");
                var productUrl = "https://ridecore.pro/products/"+productHandle;
                var productVariantId = addBtn.data("variantid");
                var productPrice = addBtn.data("price");
                var productGrams = addBtn.data("grams");
                var productAvailable = addBtn.data("available");

                jQuery.getJSON(productUrl + '.js', function(product){
                   $('#productPopup').removeClass('open');
                   var productMetafields = metafields[productHandle];
                   var builderImage = productMetafields.product_builder_image;
                   var builderThumbnail = productMetafields.product_thumbnail;

                   sessionStorage.setItem([part], JSON.stringify({handle:productHandle, title: productTitle, url:productUrl, variant:productVariantId, image:builderImage, thumb:builderThumbnail, price: productPrice, grams:productGrams, available:productAvailable}));

                  console.log(productMetafields);

                  if(currentProduct=="scooters-scooter-parts-forks"){
                    forkType = productMetafields.fork_type;
                    console.log(forkType);
                    forksSelected = true;
                    checkifShimNeeded();
                    sessionStorage.setItem("prevForkType",JSON.stringify(forkType));
                  }
                  else if(currentProduct=="scooters-scooter-parts-clamps"){
                    clampType = productMetafields.clamp_type;
                    console.log(clampType);
                    clampSelected = true;
                    checkifShimNeeded();
                    sessionStorage.setItem("prevClampType",JSON.stringify(clampType));
                  }
                  else if(currentProduct=="scooter-handlebars"){
                    barType = productMetafields.bar_type;
                    console.log(barType);
                    barsSelected = true;
                    checkifShimNeeded();
                    sessionStorage.setItem("prevBarType",JSON.stringify(barType));
                  }

                  
                   if ($('#'+part).length){
                     $('#'+part).html('<img src="'+builderImage+'" />');
                   }
                  
                   if(!productAvailable){
                      $('.componentBtn[data-part="'+part+'"]').find('.previewImage').addClass('oos');
                      //console.log('not available');
                   }
                   else{
                      $('.componentBtn[data-part="'+part+'"]').find('.previewImage').removeClass('oos');
                     //console.log('available');
                   }
                   
                   $('.componentBtn[data-part="'+part+'"]').find('.previewImage').html('<img src="'+builderThumbnail+'" />');
                   $('.componentBtn[data-part="'+part+'"]').find('.description').text(productTitle);
                   $('.componentBtn[data-part="'+part+'"]').find('.price').text('- £'+productPrice);
                   $('.componentBtn[data-part="'+part+'"]').addClass('selected');

                   priceArray[part] = productPrice;
                   weightArray[part] = productGrams;
                   productArray[part] = productVariantId;
                   stockArray[part] = productAvailable;
                   var totalPrice = (Math.round(sumValues(priceArray) * 100) / 100);
                   var discountPrice = totalPrice - (totalPrice * (discount/100));
                   $('#totalPrice').text(totalPrice.toFixed(2));
                   $('#discountedPrice').text(discountPrice.toFixed(2));
                   $('#totalWeight').text((Math.round(sumValues(weightArray) * 100) / 100000).toFixed(2));
                    
                });
              
            }
        }

      function checkifShimNeeded(){
        var shimHandle;
        if ((barType == "Titanium")&&(forkType == "IHC Forks")&&(clampType == "SCS Clamp")){
          shimHandle = "core-fork-adapter-hic-conversion-shim-kit-31-8";
          addShimtoBuilder(shimHandle);
        }
        else if ((barType == "Titanium")&&(forkType == "IHC Forks")&&(clampType == "Double Clamp")){
          console.log('ADD FORK ADAPTER IHC TO HIC CONVERSION SHIM');
          shimHandle = "core-ihc-to-hic-conversion-shim-kit-3mm";
          addShimtoBuilder(shimHandle);
        }
        else if ((forkType == "SCS / HIC Forks")&&(clampType == "Double Clamp")&&(barType == "Titanium")){
          console.log('ADD FORK ADAPTER IHC TO HIC CONVERSION SHIM');
          shimHandle = "core-fork-adapter-hic-conversion-shim-kit-31-8";
          addShimtoBuilder(shimHandle);
        }
        else{
          console.log('NO SHIM REQUIRED - REMOVE EXISTING IF PRESENT');
          $('.componentBtn[data-part="shims"]').find('.previewImage').removeClass('oos');
          $('.componentBtn[data-part="shims"]').find('.previewImage').empty();
          $('.componentBtn[data-part="shims"]').find('.description').text('Automatically added');
          $('.componentBtn[data-part="shims"]').find('.price').empty();
          $('.componentBtn[data-part="shims"]').removeClass('selected');

          if (priceArray["shims"]){
            delete priceArray["shims"];
          }

          if (weightArray["shims"]){
            delete weightArray["shims"];
          }

          if (productArray["shims"]){
            delete productArray["shims"];
          }

          if (stockArray["shims"]){
            delete stockArray["shims"];
          }

          sessionStorage.removeItem('shims');

          var totalPrice = (Math.round(sumValues(priceArray) * 100) / 100);
          var discountPrice = totalPrice - (totalPrice * (discount/100));
          $('#totalPrice').text(totalPrice.toFixed(2));
          $('#discountedPrice').text(discountPrice.toFixed(2));
          $('#totalWeight').text((Math.round(sumValues(weightArray) * 100) / 100000).toFixed(2));
          
        }

        function addShimtoBuilder(shimHandle){
          var productUrl = "https://ridecore.pro/products/"+shimHandle;
          jQuery.getJSON(productUrl + '.js', function(product){
            console.log(product);
             var productTitle = product.title;
             var productMetafields = metafields[shimHandle];
             var builderThumbnail = productMetafields.product_thumbnail;
             var productAvailable = product.available;
             var productVariantId = product.variants[0].id;
             var productPrice = product.variants[0].price;
             productPrice = Number((productPrice / 100).toFixed(2));
             var productGrams = product.variants[0].weight;

             sessionStorage.setItem("shims", JSON.stringify({handle:shimHandle, title: productTitle, url:productUrl, variant:productVariantId, thumb:builderThumbnail, price: productPrice, grams:productGrams, available:productAvailable}));

            console.log(productMetafields);
            
             if(!productAvailable){
                $('.componentBtn[data-part="shims]').find('.previewImage').addClass('oos');
                //console.log('not available');
             }
             else{
                $('.componentBtn[data-part="shims"]').find('.previewImage').removeClass('oos');
               //console.log('available');
             }
             
             $('.componentBtn[data-part="shims"]').find('.previewImage').html('<img src="'+builderThumbnail+'" />');
             $('.componentBtn[data-part="shims"]').find('.description').text(productTitle);
             $('.componentBtn[data-part="shims"]').find('.price').text('- £'+productPrice);
             $('.componentBtn[data-part="shims"]').addClass('selected');

             priceArray["shims"] = productPrice;
             weightArray["shims"] = productGrams;
             productArray["shims"] = productVariantId;
             stockArray["shims"] = productAvailable;
             var totalPrice = (Math.round(sumValues(priceArray) * 100) / 100);
             var discountPrice = totalPrice - (totalPrice * (discount/100));
             $('#totalPrice').text(totalPrice.toFixed(2));
             $('#discountedPrice').text(discountPrice.toFixed(2));
             $('#totalWeight').text((Math.round(sumValues(weightArray) * 100) / 100000).toFixed(2));
              
          }); 
        }
      }


      /* Set up main add to cart button */

      $('#mainAdd').click(function(){

        //console.log(stockArray);

        var validationFlag = false;
        var stockFlag = false;
        var cartData = [];
        
        //console.log(productArray);
        
        if (productArray.deck){
          if(stockArray.deck){
            cartData.push({
              'quantity': 1,
              'id': productArray.deck,
              'properties': {
                'scooter_builder': 'deck'
              }
            });
          }
          else{
            stockFlag = true;
          }
        }
        else{
          //console.log('deck');
          validationFlag = true;
        }

        if (productArray.forks){
          if(stockArray.forks){
            cartData.push({
              'quantity': 1,
              'id': productArray.forks,
              'properties': {
                'scooter_builder': 'forks'
              }
            });
          }
          else{
            stockFlag = true;
          }
        }
        else{
          //console.log('forks');
          validationFlag = true;
        }

        if (productArray.clamp){
          if(stockArray.clamp){
            cartData.push({
              'quantity': 1,
              'id': productArray.clamp,
              'properties': {
                'scooter_builder': 'clamp'
              }
            });
          }
          else{
            stockFlag = true;
          }
        }
        else{
          //console.log('clamp');
          validationFlag = true;
        }


        if (productArray.bars){
          if(stockArray.bars){
            cartData.push({
              'quantity': 1,
              'id': productArray.bars,
              'properties': {
                'scooter_builder': 'bars'
              }
            });
          }
          else{
            stockFlag = true;
          }
        }
        else{
          //console.log('bars');
          validationFlag = true;
        }

        if (productArray.headset){
          if(stockArray.headset){
            cartData.push({
              'quantity': 1,
              'id': productArray.headset,
              'properties': {
                'scooter_builder': 'headset'
              }
            });
          }
          else{
            stockFlag = true;
          }
        }
        else{
          //console.log('headset');
          validationFlag = true;
        }

        if (productArray.frontWheel){
          if(stockArray.frontWheel){
            cartData.push({
              'quantity': 1,
              'id': productArray.frontWheel,
              'properties': {
                'scooter_builder': 'frontWheel'
              }
            });
          }
          else{
            stockFlag = true;
          }
        }
        else{
          //console.log('front wheel');
          validationFlag = true;
        }

        if (productArray.rearWheel){
          if(stockArray.rearWheel){
            cartData.push({
              'quantity': 1,
              'id': productArray.rearWheel,
              'properties': {
                'scooter_builder': 'rearWheel'
              }
            });
          }
          else{
            stockFlag = true;
          }
        }
        else{
          //console.log('rear wheel');
          validationFlag = true;
        }

        if (productArray.griptape){
          if(stockArray.griptape){
            cartData.push({
              'quantity': 1,
              'id': productArray.griptape,
              'properties': {
                'scooter_builder': 'griptape'
              }
            });
          }
          else{
            stockFlag = true;
          }
        }
        else{
          //console.log('griptape');
          validationFlag = true;
        }

        if (productArray.grip){
          if(stockArray.grip){
            cartData.push({
              'quantity': 1,
              'id': productArray.grip,
              'properties': {
                'scooter_builder': 'grip'
              }
            });
          }
          else{
            stockFlag = true;
          }
        }
        else{
          //console.log('grip');
          validationFlag = true;
        }

        if (productArray.shims){
          if(stockArray.shims){
            cartData.push({
              'quantity': 1,
              'id': productArray.shims,
              'properties': {
                'scooter_builder': 'shims'
              }
            });
          }
          else{
            stockFlag = true;
          }
        }

        /* Validate Builder Before Adding to cart */

        if(validationFlag){
          $('#validationPopup').addClass('open');
          $('#validationBack').click(function(){
            $('#validationPopup').removeClass('open');
          });
          $('#validationPopup .closePopup').click(function(){
            $('#validationPopup').removeClass('open');
          });
          
          $('#validationContinue').click(function(){
            $('#validationPopup').removeClass('open');
            if(stockFlag){
              $('#stockPopup').addClass('open');
              $('#stockBack').click(function(){
                $('#stockPopup').removeClass('open');
              });
              $('#stockPopup .closePopup').click(function(){
                $('#stockPopup').removeClass('open');
              });
              $('#stockContinue').click(function(){
                $('#stockPopup').removeClass('open');
                addToCart();
              });
            }
            else{
              addToCart();
            }
              
          });
          
        }
        else{
          if(stockFlag){
            $('#stockPopup').addClass('open');
            $('#stockBack').click(function(){
              $('#stockPopup').removeClass('open');
            });
            $('#stockPopup .closePopup').click(function(){
              $('#stockPopup').removeClass('open');
            });
            $('#stockContinue').click(function(){
              $('#stockPopup').removeClass('open');
              addToCart();
            });
          }
          else{
            addToCart();
          }
        }

        /* ADD TO CART !!!! */

        function addToCart(){

              let formData = {
               'items': cartData
              };

              console.log(formData);
            
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then(response => {
                var cart = new theme.CartDrawer
                cart.init()
                cart.open();
                return response.json();
              })
              .catch((error) => {
                console.error('Error:', error);
              });
          
        }
        
      });


    });

})(jQuery); 